import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['source']

  copy = async event => {
    event.preventDefault()
    const text = this.sourceTarget.textContent.trim()

    try {
      await navigator.clipboard.writeText(text)
      this.showFeedback(event.srcElement || event.target)
    } catch (err) {
      console.error('Failed to copy text: ', err)
    }
  }

  showFeedback = icon => {
    if (!icon) return
    if (icon.tagName !== 'ION-ICON') return

    const originalName = icon.getAttribute('name')
    if (originalName === 'checkmark-outline') return

    icon.setAttribute('name', 'checkmark-outline')

    setTimeout(() => {
      icon.setAttribute('name', originalName)
    }, 1200)
  }
}

